module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-phone-7d614af4f22875f47d64d6a582c63185.svg";